import { ExternalLink, Landmark } from 'lucide-react'
import type { OfficialSource } from '../types/content'

interface OfficialSourcesProps {
  disclaimer: string
  sources: OfficialSource[]
}

export default function OfficialSources({ disclaimer, sources }: OfficialSourcesProps) {
  return (
    <section className="official-sources" aria-labelledby="official-sources-title">
      <div className="official-sources__heading">
        <Landmark aria-hidden="true" size={20} />
        <div>
          <p className="eyebrow">정부 정보 출처</p>
          <h2 id="official-sources-title">공식 원문에서 최종 확인</h2>
        </div>
      </div>
      <p className="official-sources__disclaimer">{disclaimer}</p>
      <ul>
        {sources.map((source) => (
          <li key={source.url}>
            <a href={source.url} target="_blank" rel="noreferrer">
              <span><strong>{source.name}</strong><small>{source.purpose}</small><code>{source.url}</code></span>
              <ExternalLink aria-hidden="true" size={17} />
            </a>
          </li>
        ))}
      </ul>
    </section>
  )
}
